import { useStoreState } from 'providers/StoreStateContext';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useGetTheme } from 'services/theme';

export default function PublicRoute() {
  const { token } = useStoreState();
  const navigate = useNavigate();
  const currentTheme = useGetTheme();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token]);

  return <Outlet />;
}
